var GroupedJSONHelper = {
    groupResultsToggle: (groupedResults, parentId) => {
    	//console.log('groupResultsToggle before', groupedResults);
        var updatedGroupedResults = {};
    	Object.keys(groupedResults).forEach(function(groupedResultsKey){
        	if(groupedResults[groupedResultsKey].withDisambiguationResults && groupedResults[groupedResultsKey].withDisambiguationResults[parentId]){
                groupedResults[groupedResultsKey].withDisambiguationResults[parentId] = groupedResults[groupedResultsKey].withDisambiguationResults[parentId].map((function(withDisambiguationResult){
                	if(withDisambiguationResult.raw && withDisambiguationResult.raw.entities && withDisambiguationResult.raw.entities) {
                        withDisambiguationResult.raw.entities = withDisambiguationResult.raw.entities.map(function(entity){
                        	entity.disambiguationResults = entity.disambiguationResults.map(function(disambiguationResult){
                                	if (disambiguationResult.id === parentId) {
                                        disambiguationResult.childrenVisible = !disambiguationResult.childrenVisible;
                                    } else {
                                        disambiguationResult.visible = !disambiguationResult.visible;
                                    }
                                    return disambiguationResult;
							});
                        	return entity;
						});
                    }
                	return withDisambiguationResult;
				}))
			}
			//console.log('key', groupedResultsKey, groupedResults[groupedResultsKey]);
            updatedGroupedResults[groupedResultsKey] = groupedResults[groupedResultsKey];
		});
        //console.log('updatedGroupedResults after', updatedGroupedResults);
		return updatedGroupedResults;
	},
	groupResults: (groups) => {
		
		var groupedResults =  { };

		for(var entityType in groups) {
			var entityGroup = groups[entityType];
			groupedResults[entityType] = { withDisambiguationResults: { }, withoutDisambiguationResults: { } };

			var entityGroup = entityGroup.reduce(function(groupedEntityResults, currentResult, index, allResults) {

                currentResult.raw.entities.forEach(function(entity){
                    var firstItem = true, parent = null;
                    if(entity.disambiguationResults) {
                        entity.disambiguationResults.forEach(function (disambiguationResult) {
                            if (firstItem) {
                                disambiguationResult.visible = true; //always showing first one...
                                disambiguationResult.isParent = true;
                                disambiguationResult.childrenVisible = false;
                                disambiguationResult.hasChildren = false;
                                parent = disambiguationResult;
                                firstItem = false;
                            } else {
                                disambiguationResult.visible = false;
                                disambiguationResult.isParent = false;
                                disambiguationResult.parentId = parent.id;
                                parent.hasChildren = true;
                            }
                        });
                    }
                });

				var currentEntity = currentResult.raw.entities[0];

				//console.log('currentEntity.disambiguationResults[0] => ', currentEntity.disambiguationResults[0])
				if(currentEntity.disambiguationResults && currentEntity.disambiguationResults[0]) {
					
					var entityId = currentEntity.disambiguationResults[0].id;

					//console.log(entityId,currentEntity.disambiguationResults[0],  currentResult);

					if(groupedEntityResults[entityType].withDisambiguationResults[entityId]) {
						groupedEntityResults[entityType].withDisambiguationResults[entityId].push(currentResult);
					} else {
						groupedEntityResults[entityType].withDisambiguationResults[entityId] = [ currentResult ];
					}
				} else {
                    //var id = 'entity_' + currentResult.raw.anchor.text;
                    var id = 'entity_' + currentEntity.normalizedText;

                    //console.log('pushing currentResult => ' + JSON.stringify(currentResult) + ' to => ' + id);
				
                    if (id in groupedEntityResults[entityType].withoutDisambiguationResults) {
                        groupedEntityResults[entityType].withoutDisambiguationResults[id].push(currentResult); 
                    } else {
                        groupedEntityResults[entityType].withoutDisambiguationResults[id] = [ currentResult ];
                    }
				}

				return groupedEntityResults;
			}, groupedResults);
		}
		return groupedResults;
	},
	mapGroups: (cb, groups) => {
		//console.log('groups', groups);
		var i = 0, results = [];

		for(var type in groups) {
			
			var groupedJsonResults = cb(type, groups[type], i);
			
			results.push(groupedJsonResults);
			i++
		}

		return results;
	},
};

module.exports = GroupedJSONHelper;
